import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ose-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements ControlValueAccessor, OnInit {
  public fc = new FormControl();

  @Output() change = new EventEmitter<boolean>();
  @Input() disabled: boolean;
  @Input() classes: string;

  constructor() {
    this.fc.valueChanges.subscribe((val) => {
      this.change.emit(val);
      this.onChange(val);
    });
  }

  ngOnInit(): void {
    this.disabled ? this.fc.disable() : this.fc.enable();
  }

  onChange(_: any): void {
    // EMPTY
  }

  onTouched(_: any): void {
    // EMPTY
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(obj: any): void {
    this.fc.patchValue(obj);
  }
}
